// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.access-granted[data-v-87a91170] {\r\n\tcolor: var(--main-success);\n}\n.access-denied[data-v-87a91170] {\r\n\tcolor: var(--main-danger);\n}\n.profile-img[data-v-87a91170] {\r\n\twidth: 24px;\r\n\theight: 24px;\r\n\tborder-radius: 50%;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
